import { useCallback, useEffect, useState } from "react";

/**
 * useCommandPaletteShortcut — toggles open state on Cmd/Ctrl+K
 * (DESIGN-SYSTEM §6.8). Returns `[open, setOpen]`; wire `open`/`onOpenChange`
 * into <CommandPalette>. Lives in lib/ (not the component file) so the
 * react-refresh "components-only exports" lint rule stays satisfied.
 */
export function useCommandPaletteShortcut(): [boolean, (open: boolean) => void] {
  const [open, setOpen] = useState(false);

  const toggle = useCallback(() => setOpen((o) => !o), []);

  useEffect(() => {
    function onKey(e: KeyboardEvent) {
      if (e.key.toLowerCase() === "k" && (e.metaKey || e.ctrlKey)) {
        e.preventDefault();
        toggle();
      }
    }
    document.addEventListener("keydown", onKey);
    return () => document.removeEventListener("keydown", onKey);
  }, [toggle]);

  return [open, setOpen];
}
